'use strict';

angular.module('adelementAdminApp')
    .factory('AeAdvertisers', function ($resource, DateUtils) {
        return $resource('api/aeAdvertiserss/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    //data.timezone = DateUtils.convertDateTimeFromServer(data.timezone);
                    data.creationTimestamp = DateUtils.convertDateTimeFromServer(data.creationTimestamp);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    });
